/*
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-28 13:32:38
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-25 16:26:35
 */
import { defineStore } from 'pinia';
import { useGameListSocket } from '~/socket/gamelist';
import type { GameListResponseState } from '~/socket/gamelist/dto';

type stateType = Partial<GameListResponseState>;
export const useGameIdListStore = defineStore('gameIdList', {
    state: () => ({
        gameIdNameList: [], // 旧值：import {gameListResponseState} from '**'; 
        gameIdList: [],

    }),
    actions: {
        setState(partialState: stateType) {
            Object.assign(this, partialState);
        },
        /**
         * 初始化
         * @returns 成功状态
         */
        async initData(
            iTimeoutMs=0,
        ){
            const {oPromise, resolve, reject} = createPromise();
            const t01 = Date.now();
            let timer01 = null;
            useGameListSocket().EMIT_GET_ORIGINAK_GAMES({}, (aGames)=>{
                // if (1 && (import.meta.dev || import.meta.env.DEV_MODE)){ 
                //     aGames.unshift({
                //         ...aGames[0],
                //         "id": 4569,
                //         "name": "goldenFlower",
                //         "title": "goldenFlower",
                //         "title_cn": "炸金银花",
                //         "sort": 2,
                //     });
                // }
                clearTimeout(timer01);
                if (import.meta.dev){
                    console.log('游戏列表查询完毕，耗时ms：', Date.now() - t01); // ≈10ms
                }
                this.gameIdList = aGames; 
                this.gameIdNameList = deepCopy(aGames); 
                resolve({success: true});
            });
            if (iTimeoutMs > 0){
                const t01 = Date.now();
                timer01 = setTimeout(()=>{
                    console.warn('查询游戏列表超时, used:', Date.now() - t01);
                    resolve({success: false, msg: '查询游戏列表超时'});
                }, iTimeoutMs);
            }
            return oPromise;
        },
    },
    getters: {
        getState: (state) => state,
    },
});

